window.refresh = () => {
    const refreshCustomerPortalState = new CustomEvent("Affinity:refresh");
    document.dispatchEvent(refreshCustomerPortalState)
}

window.formatSimpleAddress = (address) => {
    if (!address) {
        return ''
    }
    return `${address.address1}${address.address2 !== null ? `\n${address.address2}` : ''}`
}

window.formatPriceStoreCurrency = (price) => {
    const newPrice = (Number(price) / 100).toLocaleString('en-EN', {minimumFractionDigits: 2});
    return `${window.TIEGE.affinity.currency_symbol}${newPrice.replace('.00', '')} ${window.TIEGE.affinity.currency_code}`
}

window.displayNotification = (type, message) => {
    const styleClass = type === 'error' ? 'affinity-error' : 'affinity-success';
    const id = type === 'error' ? `error-${uuidv4()}` : `success-${uuidv4()}`;
    $('#recharge-customer-portal').append(`<div class="${styleClass}" id="${id}">`+
          '<div>'+(type === 'error' ? 
                   '<svg xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M9.017 1.2a1.143 1.143 0 0 0-2.034 0L.697 13.771a1.143 1.143 0 0 0 1.017 1.658h12.572a1.143 1.143 0 0 0 1.017-1.658L9.017 1.2Z" stroke="#FFFFFF" stroke-width="1.143px" stroke-linecap="round" stroke-linejoin="round" fill="none"></path><circle cx="8" cy="12" transform="rotate(-180 8 12)" fill="#FFFFFF" r="1"></circle><path d="M8 9V5.5" stroke="#FFFFFF" stroke-width="1.2px" stroke-linecap="round" stroke-linejoin="round" fill="none"></path></svg>' :
                   '<svg xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="13"><path d="M14.5 1 4.967 12 1.5 8.333" stroke="#FFFFFF" stroke-width="1.2px" stroke-linecap="round" stroke-linejoin="round" fill="none"></path></svg>') +
          `<span>${message}</span></div>`+
          '<button><svg xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="m10.423 5.577-4.846 4.846M5.577 5.577l4.846 4.846M8 15.429A7.429 7.429 0 1 0 8 .57 7.429 7.429 0 0 0 8 15.43Z" stroke="#FFFFFF" stroke-width="1.2px" stroke-linecap="round" stroke-linejoin="round" fill="none"></path></svg></button>'+
        '</div>')
    $(`#${id} button`).on('click', ()  => {
        $(`#${id}`).remove()
    });

    setTimeout(function() {
      if ($(`#${id}`)) {
          $(`#${id}`).fadeOut(1000, () => {$(`#${id}`).remove()})
      }
    }, 10000)
}
